import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Trámite colors kept distinct for differentiation, on a black + gold canvas.
export const TRAMITES = {
  MOD_10: {
    key: "MOD_10",
    label: "MOD. 10",
    color: "#1E40AF",
    bg: "bg-blue-50",
    text: "text-blue-700",
    border: "border-blue-200",
    dot: "bg-blue-500",
  },
  MOD_40: {
    key: "MOD_40",
    label: "MOD. 40",
    color: "#047857",
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    border: "border-emerald-200",
    dot: "bg-emerald-500",
  },
  RETIRO_DESEMPLEO: {
    key: "RETIRO_DESEMPLEO",
    label: "RETIRO POR DESEMPLEO",
    color: "#B45309",
    bg: "bg-amber-50",
    text: "text-amber-700",
    border: "border-amber-200",
    dot: "bg-amber-500",
  },
  INCREMENTO: {
    key: "INCREMENTO",
    label: "INCREMENTO",
    color: "#6D28D9",
    bg: "bg-purple-50",
    text: "text-purple-700",
    border: "border-purple-200",
    dot: "bg-purple-500",
  },
};

export const TRAMITE_LIST = Object.values(TRAMITES);

export const MXN = (n) =>
  new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    maximumFractionDigits: 2,
  }).format(Number(n || 0));

export const MONTH_NAMES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];
